import { render, staticRenderFns } from "./SamplingOrderCreationForm.vue?vue&type=template&id=3556ddd9&scoped=true&lang=html&"
import script from "./SamplingOrderCreationForm.vue?vue&type=script&lang=js&"
export * from "./SamplingOrderCreationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3556ddd9",
  null
  
)

export default component.exports